import Fuse from 'fuse.js';
export default {
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else if (this.searchQuery) {
        result = []
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: '',
      searchedData: [],
      fuseSearch: null
    }
  },
  methods: {
    sortChange({ prop, order }) {
      if (prop) {
        this.tableData.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.tableData.sort((a, b) => {
          return a.id - b.id
        })
      }
    },
    initSearch(data){
      this.searchedData = data
      this.fuseSearch = new Fuse(data, {
        keys: ['Number', 'EnterpriseName','PackageName','Email'],
        threshold: 0.09,
		location: 0,
		distance: 100,
		maxPatternLength: 20,
		minMatchCharLength: 1
      });

      if (this.searchQuery !== ''){
        this.searchedData = this.fuseSearch.search(this.searchQuery);
      }
    }
  },
  mounted() {
    this.initSearch(this.tableData)
  },
  watch: {
    tableDataOrg(value){
      this.initSearch(this.tableData)
    },
    enterprise_id(value){
      this.initSearch( this.tableData)
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== '') {
        result = this.fuseSearch.search(this.searchQuery);
      } 

      // if (value !== '') {
      //   result = this.tableData.filter((i)=> {
      //     return i.Number.search(value) != -1 || i.EnterpriseName.search(value) != -1 || i.ChargeNumber.search(value) != -1
      //   })
      // }
      this.searchedData = result;
    }
  }
}
